import React, { useState, useEffect } from 'react';
import { get } from 'global/lib/lodash';
import { Icon, IconButton } from '@mui/material';
import { withRouter } from 'react-router-dom';
import useStyles from './styles';
import { Column, Row } from 'global/components/row';
import { Text } from 'global/components/text';
import { Button } from 'global/components/Button';
import { _size } from 'global/utils';
import colors from 'global/styles/colors';
import SnackAlerts from 'global/components/snack-alerts';
import EditionList from '../../document/EditionList';
import DocumentList from '../../document/DocumentList';
import Document from '../../document/Document';
import { CenterLoader } from 'global/styles';
import useBodyOverflow from 'global/hooks/useBodyOverflow';

export const AddEditionsList = withRouter((props) => {
  const { doc } = props;
  const { editionDocuments } = doc;

  const { setBodyOverflow } = useBodyOverflow();

  const classes = useStyles();

  const [state, setState] = useState({
    items: editionDocuments,
    selectedEdition: undefined,
    selectedDoc: undefined,
    showList: false,
    selectedDocs: {},
  });

  const [alerts, setAlerts] = useState();

  const edid = get(state, 'selectedEdition.id');
  const classid = get(state, 'selectedDoc.classificationId');

  const edClick = (ed) => {
    setState((s) => ({ ...s, selectedEdition: ed }));
  };

  const docClick = (doc) => {
    setState((s) => ({ ...s, selectedDoc: doc }));
  };

  const addDoc = () => {
    setState((s) => ({
      ...s,
      selectedDocs: {
        ...s.selectedDocs,
        [get(state, 'selectedDoc.id')]: state.selectedDoc,
      },
    }));
  };

  const removeDoc = (k) => {
    setState((s) => {
      delete s.selectedDocs[k];
      return {
        ...s,
      };
    });
  };

  const submit = async () => {
    try {
      setState((s) => ({ ...s, loading: true }));
      await props.addDocs(Object.keys(state.selectedDocs).map((k) => state.selectedDocs[k]));
      props.onClose(true);
    } catch (err) {
      setAlerts({ message: err.message, severity: 'error' });
    } finally {
      setState((s) => ({ ...s, loading: false }));
    }
  };

  const showEdition = !state.selectedEdition;
  const showDocList = !!state.selectedEdition;
  const showDoc = state.selectedDoc;

  useEffect(() => {
    setBodyOverflow(true);

    return () => {
      setBodyOverflow(false);
    };
  }, [showEdition, showDoc, showDocList]);

  if (state.loading) {
    return (
      <div className={classes.addedition}>
        <CenterLoader />
      </div>
    );
  }

  if (state.showList) {
    return (
      <div className={classes.addedition}>
        <Column center style={{ padding: 8, marginTop: 16 }}>
          <Text type="headline_medium" bold>{`You have selected ${_size(state.selectedDocs)} documents`}</Text>
          <Column style={{ padding: 8 }}>
            {Object.keys(state.selectedDocs).map((k) => {
              return (
                <Row>
                  <IconButton onClick={() => removeDoc(k)} size="large">
                    <Icon>close</Icon>
                  </IconButton>
                  <Text className="docText">{get(state.selectedDocs, `${k}.document.classification.system.name`)}</Text>
                  <Text className="docText">{get(state.selectedDocs, `${k}.document.name`)}</Text>
                  <Text className="docText">{get(state.selectedDocs, [k, 'documentableType'])}</Text>
                </Row>
              );
            })}
          </Column>

          <Row center className="listButtons">
            <Button bgColor={colors.danger} onClick={() => setState((s) => ({ ...s, showList: false }))} startIcon={<Icon>close</Icon>}>
              BACK TO ADD
            </Button>
            <Button onClick={submit} startIcon={<Icon>save</Icon>}>
              ADD TO EDITION
            </Button>
          </Row>
        </Column>

        <SnackAlerts alerts={alerts} setAlerts={setAlerts} />
      </div>
    );
  }

  const closeProps = (from = 'doclist') => ({
    component: undefined,
    to: undefined,
    onClick: () => {
      if (from === 'doclist') {
        setState((s) => ({ ...s, selectedDoc: null, selectedEdition: null }));
      } else {
        setState((s) => ({ ...s, selectedDoc: null }));
      }
    },
  });

  return (
    <div className={classes.addedition}>
      {showEdition && <EditionList showCourses={false} showCoursesInList={true} showReview={false} isModal={true} onClick={edClick} />}

      {showDocList && (
        <DocumentList
          isModal={true}
          closeProps={closeProps()}
          onClick={docClick}
          libid={state.selectedEdition.id}
          path={`document/${get(state, 'selectedDoc.classificationId')}`}
          isDocumentPath={showDoc}
        />
      )}

      {showDoc && <Document classificationId={classid} onDoc={docClick} isModal editionId={edid} closeProps={closeProps('document')} />}

      <div className="buffer" />

      <div className={'buttonContainer'}>
        <Row className="buttonRow">
          <Text>{`${_size(state.selectedDocs)} Selected Documents`}</Text>
          <Button disabled={!showDoc} onClick={addDoc} startIcon={<Icon>add_circle</Icon>}>
            ADD THIS DOCUMENT
          </Button>
          <Button disabled={!_size(state.selectedDocs)} onClick={() => setState((s) => ({ ...s, showList: true }))} startIcon={<Icon>double_arrow</Icon>}>
            REVIEW ADDITIONS
          </Button>
        </Row>
      </div>

      <SnackAlerts alerts={alerts} setAlerts={setAlerts} />
    </div>
  );
});
